export default {
    namespaced: true,
    state: {
        step: 1,
        vertretungsberechtigung: null,
        model: null,
        versendenNEZOPostfach: null,
        isVertretung: false,
        datenRichtigkeit: false,
        antragsbestaetigung: false,
        wmiArt: null,
        wmi3Stellen: null,
        wmi6Stellen: null,
        istGesiegelteBestaetigung: null
    },
    getters: {
        isVertretung (state) {
            return state.isVertretung
        },
        wmiArt (state) {
            return state.wmiArt
        },
        wmi3Stellen (state) {
            return state.wmi3Stellen
        },
        wmi6Stellen (state) {
            return state.wmi6Stellen
        },
        versendenNEZOPostfach (state) {
            return state.versendenNEZOPostfach
        },
        vertretungsberechtigung (state) {
            return state.vertretungsberechtigung
        },
        datenRichtigkeit (state) {
            return state.datenRichtigkeit
        },
        antragsbestaetigung (state) {
            return state.antragsbestaetigung
        },
        istGesiegelteBestaetigung (state) {
            return state.istGesiegelteBestaetigung
        },
        step (state) {
            return state.step
        },
        model (state) {
            return state.model
        }
    },
    mutations: {
        reset (state) {
            state.loggedin = false
            state.vertretungsberechtigung = null
            state.versendenNEZOPostfach = null
            state.istGesiegelteBestaetigung = null
            state.isVertretung = false
            state.datenRichtigkeit = false
            state.antragsbestaetigung = false
            state.wmiArt = null
            state.wmi3Stellen = null
            state.wmi6Stellen = null
        },
        isVertretung (state, isVertretung) {
            state.isVertretung = isVertretung
        },
        wmiArt (state, wmiArt) {
            state.wmiArt = wmiArt
        },
        wmi3Stellen (state, wmi3Stellen) {
            state.wmi3Stellen = wmi3Stellen
        },
        wmi6Stellen (state, wmi6Stellen) {
            state.wmi6Stellen = wmi6Stellen
        },
        versendenNEZOPostfach (state, versendenNEZOPostfach) {
            state.versendenNEZOPostfach = versendenNEZOPostfach
        },
        vertretungsberechtigung (state, vertretungsberechtigung) {
            state.vertretungsberechtigung = vertretungsberechtigung
        },
        datenRichtigkeit (state, datenRichtigkeit) {
            state.datenRichtigkeit = datenRichtigkeit
        },
        antragsbestaetigung (state, antragsbestaetigung) {
            state.antragsbestaetigung = antragsbestaetigung
        },
        step (state, step) {
            state.step = step
        },
        istGesiegelteBestaetigung (state, istGesiegelteBestaetigung) {
            state.istGesiegelteBestaetigung = istGesiegelteBestaetigung
        },
        increaseStep (state) {
            state.step++
        },
        decreaseStep (state) {
            state.step--
        },
        model (state, model) {
            state.model = model
        }
    },
    actions: {

    }
}
